export const formatPublicReference = (ref: string): string => {
  if (!ref) return "";
  return ref.match(/.{1,4}/g)!.join("-");
};
